export default __webpack_public_path__ + "static/media/next-icon.d29140cf.svg";